import React from 'react'
import { Redirect } from 'react-router-dom'
import { useAuth } from 'providers/auth-provider'
import {
  salesUsersCanCreate,
  salesUsersCanRead,
  salesUsersCanUpdate
} from '../helpers/sales-users-access-helper'

const permissionCheck = {
  read: salesUsersCanRead,
  create: salesUsersCanCreate,
  update: salesUsersCanUpdate
}

export const withSalesUsersAccess = (Component, permission = 'read') => {
  const GuardedSalesUsersPage = (props) => {
    const { user } = useAuth()
    const check = permissionCheck[permission] || permissionCheck.read

    if (!check(user)) return <Redirect to='/app' />

    return <Component { ...props } />
  }

  GuardedSalesUsersPage.displayName = `withSalesUsersAccess(${Component.displayName || Component.name || 'Component'})`

  return GuardedSalesUsersPage
}
